import type { MenuCategory } from "@workspace/product-catalog-types";

/**
 * HA-890 AC4 (D-HA-23 23-3): whether a category is shown is the menu's own choice, so the terminal offers only the shown
 * ones, in the menu's order. A hidden category is no button at any level (its sub-categories are reached through it).
 */
export const visibleCategories = (categories: MenuCategory[]) =>
	categories.filter((category) => category.isVisible);
